import { UserManager, WebStorageStateStore, Log } from 'oidc-client-ts'
import store from '@/store'

class AuthClient {
  constructor () {
    this.settings = {
      // Where the tokens will be stored
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      // Auth server information
      authority: process.env.VUE_APP_OAUTH_URI,
      metadata: {
        issuer: process.env.VUE_APP_AUTH_SERVER_HOST,
        authorization_endpoint: process.env.VUE_APP_OAUTH_AUTHORIZATION_URI,
        token_endpoint: process.env.VUE_APP_OAUTH_ACCESS_TOKEN_URI,
        end_session_endpoint: process.env.VUE_APP_OAUTH_LOGOUT_URI
      },
      // The name of the client in Keycloak setup for this service
      client_id: process.env.VUE_APP_OAUTH_CLIENT_ID,
      client_secret: process.env.VUE_APP_OAUTH_CLIENT_SECRET,
      // Send client ID and secret encoded as a basic authentication
      client_authentication: 'client_secret_basic',
      // Where to redirect the user to after successful authentication
      redirect_uri: process.env.VUE_APP_OAUTH_REDIRECT_URI,
      //
      post_logout_redirect_uri: process.env.VUE_APP_OAUTH_LOGOUT_REDIRECT_URI,
      // "openid" tells the server that this client uses oidc for authentication
      scope: process.env.VUE_APP_OAUTH_SCOPES
    }
    this.userManager = new UserManager(this.settings)

    if (process.env.VUE_APP_OAUTH_CLIENT_DEBUG === 'true') {
      // Set browser's console as logging output
      Log.setLogger(console)
    }
  }

  async logout () {
    await this.userManager.signoutRedirect()
  }

  async logoutCallback () {
    await this.userManager.signoutRedirectCallback()
  }

  async getUser () {
    return await this.userManager.getUser()
  }

  async login () {
    const width = 482
    const maxWidth = window.screen.width
    const height = 625
    const maxHeight = window.screen.height
    await this.userManager.signinPopup({
      popupWindowFeatures: {
        location: false,
        menubar: false,
        width: width > maxWidth ? maxWidth : width,
        height: height > maxHeight ? maxHeight : height
      }
    })
  }

  async loginCallback () {
    await this.userManager.signinPopupCallback()
  }

  async refreshToken () {
    try {
      await this.userManager.signinSilent()
    } catch (error) {
      store.dispatch('auth/logout')
    }
  }
}

const authClientInstance = new AuthClient()
authClientInstance.userManager.events.addAccessTokenExpired(() => {
  if (authClientInstance.userManager.settings.automaticSilentRenew) {
    authClientInstance.refreshToken()
  }
})

export {
  AuthClient,
  authClientInstance
}
